const isWhiteColor = (str: string): boolean =>
  [
    "white",
    "#ffffff",
    "#fff",
    "rgb(255,255,255)",
    "rgba(255,255,255,1)",
    "cmyk(0%, 0%, 0%, 0%)",
    "hsl(0, 0%, 100%)",
  ].includes(str);

export default isWhiteColor;
